import axios from 'axios';

const stagingServer = `https://testgame.pocketrockets.space`;
const liveServer = `https://game.pocketrockets.space`;
const staging = false;

export const baseURL = process.env.NODE_ENV === 'development' ? '' : staging ? stagingServer : liveServer;

export default axios.create({
	baseURL: baseURL,
	withCredentials: true, // Include cookies in requests (required for session-based auth)
});
